import { LandingPageSettingEnum, UserSettingTypesEnum } from '../../utilities/Constants';

import { IMultiSelectOption } from '../../interfaces/ILookup';
import { SelectDropdownUserSetting } from './SelectDropdownUserSetting';
import { useCaseFileModelContext } from '../../contexts/useCaseFileModelContext';

export function PreferredSameCaseZoneGroup() {
    const { userCaseFileModelsQuery } = useCaseFileModelContext();

    const options =
        userCaseFileModelsQuery?.data?.map(
            (caseFileModel) =>
                ({
                    guid: caseFileModel.guid,
                    value: caseFileModel.id.toString(),
                    label: caseFileModel.displayName,
                } as IMultiSelectOption)
        ) ?? [];

        return (
        <SelectDropdownUserSetting
            helpText={'Default zone group for the quad.'}
            helpTitle={'Preferred Same Case Zone Group'}
            label={'Preferred Same Case Zone Group'}
            options={options}
            settingType={UserSettingTypesEnum.PreferredSameCaseZoneGroup}
        />
    );
}
